import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, ArrowRight, FileDown } from "lucide-react";
import { products as fallback } from "../mock";
import PageHero from "../components/PageHero";
import CTASection from "../components/CTASection";
import { getProducts } from "../lib/api";

const categories = ["All", "Manual Controls", "Electric Motors", "Automation"];

const Products = () => {
  const [active, setActive] = useState("All");
  const [products, setProducts] = useState(fallback);

  useEffect(() => {
    getProducts()
      .then((res) => { if (res.data.length) setProducts(res.data); })
      .catch(() => {});
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const filtered = active === "All" ? products : products.filter((p) => p.category === active);

  return (
    <div>
      <PageHero
        eyebrow="Our Range"
        title="Products"
        subtitle="Teleflex manual winders, electric window motors, automatic natural ventilation and the electrical controls that bring it all together."
      />

      <section className="bg-white py-12 md:py-16">
        <div className="mx-auto max-w-7xl px-5 md:px-8">
          <div className="mb-10 flex flex-wrap justify-center gap-3">
            {categories.map((c) => (
              <button
                key={c}
                onClick={() => setActive(c)}
                className={`rounded-full px-5 py-2.5 text-sm font-semibold transition-colors ${
                  active === c
                    ? "bg-[#1d4ed8] text-white"
                    : "border border-gray-200 bg-white text-gray-700 hover:border-[#1d4ed8] hover:text-[#1d4ed8]"
                }`}
              >
                {c}
              </button>
            ))}
          </div>

          <div className="grid gap-8">
            {filtered.map((p, i) => (
              <div
                key={p.id}
                className={`grid items-center gap-8 overflow-hidden rounded-2xl border border-gray-100 bg-white shadow-sm lg:grid-cols-2 ${
                  i % 2 === 1 ? "lg:[&>div:first-child]:order-2" : ""
                }`}
              >
                <div className="img-zoom h-72 lg:h-full lg:min-h-[340px]">
                  <img src={p.image} alt={p.name} className="h-full w-full object-cover" />
                </div>
                <div className="p-8 md:p-10">
                  <span className="text-xs font-semibold uppercase tracking-widest text-[#1d4ed8]">{p.category}</span>
                  <h2 className="mt-2 font-head text-2xl font-700 text-[#0f2a5a]">{p.name}</h2>
                  <p className="mt-3 text-base leading-relaxed text-gray-600">{p.summary}</p>
                  <ul className="mt-5 space-y-2.5">
                    {p.features.map((f) => (
                      <li key={f} className="flex items-start gap-2.5 text-sm text-gray-700">
                        <CheckCircle2 size={18} className="mt-0.5 shrink-0 text-[#1d4ed8]" /> {f}
                      </li>
                    ))}
                  </ul>
                  <div className="mt-7 flex flex-wrap gap-3">
                    <Link to="/contact" className="btn-primary inline-flex items-center gap-2 rounded-md px-6 py-3 text-sm font-semibold">
                      Enquire about this product <ArrowRight size={16} />
                    </Link>
                    <Link to="/contact" className="btn-ghost inline-flex items-center gap-2 rounded-md border border-[#0f2a5a]/20 px-6 py-3 text-sm font-semibold text-[#0f2a5a] hover:border-[#1d4ed8] hover:text-[#1d4ed8]">
                      <FileDown size={16} /> Request datasheet
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CTASection />
    </div>
  );
};

export default Products;
